import { createContext, useContext } from "react";

export interface CooperatieAccess {
  id: string;
  naam: string | null;
  /** null = hele coöperatie (corporatie-gebruiker / HDM) */
  comakers: { id: string; naam: string | null }[] | null;
}

export interface AuthUser {
  email: string;
  display_name: string;
  is_admin: boolean;
  role: "hdm" | "corporatie" | "comaker" | "none" | string;
  provider: string;
  cooperaties: CooperatieAccess[];
}

export interface AuthState {
  user: AuthUser | null;
  /** false bij SKIP_AUTH (dev): geen uitlog-knop */
  canLogout: boolean;
  logout: () => void;
}

export const AuthContext = createContext<AuthState>({
  user: null,
  canLogout: false,
  logout: () => undefined,
});

export const useAuth = () => useContext(AuthContext);
